import React, { Component } from 'react';
import NoData from './noData';
import ItemInput from './itemInput';
import Loading from './loading';
import $ from 'jquery';

class CardItem extends Component {
  constructor(props) {
    super(props);
  }

  handleCreateClick = e => {
    $("#fname").focus();
  };

  render() {
    let {
      listId,
      listName,
      items,
      newItemsToSave,
      handleAddNewItemToSave,
      handleEditButton,
      handleDeleteButton,
      handleCancel,
      handleSave,
      languageFilters,
      language,
      loading
    } = this.props;

    return (
      <div className="card-container bd-bottom">
        <div className="header-one">
          <div className="item-right">
            <h5>
              {language.card.item.title}
              {listId ? " " + listName : ""}
            </h5>
          </div>
          {listId &&
            <div className="right-item right-float-item" onClick={this.handleCreateClick}>
              <div>
                <span className={'fa-stack fa-1x orange-plus list-icon-create'}>
                  <i className="fas fa-circle fa-stack-1x " />
                  <i className="fas fa-plus fa-stack-1x fa-inverse" />
                </span>
                <span className="create-text"> {language.card.item.create} </span>
              </div>
            </div>
          }
        </div>
        <div className="header-two">
          <div className="header-two-item-right">
            <h5>{language.card.item.name}</h5>
          </div>
          <div className="header-two-right-item">
            <div>
              <h5>{language.card.item.action}</h5>
            </div>
          </div>
        </div>
        <div className={listId ? 'card-content-input' : 'card-content'}>
          {listId ? (
            <ItemInput
              listName={listName}
              items={items}
              handleAddNewItemToSave={handleAddNewItemToSave}
              handleEditButton={handleEditButton}
              handleDeleteButton={handleDeleteButton}
              languageFilters={languageFilters}
              language={language}
            />
          ) : (
            <NoData legend={language.card.item.legend_text} />
          )}
          {loading && <Loading />}
        </div>
        {!loading && 
          <div className={`${newItemsToSave ? 'btn-container' : 'btn-hide'}`}>
            <button className="btn btn-secondary" onClick={handleSave}>
              {language.card.item.btn_save}
            </button>
          </div>
        }
        {!loading &&
          <div className={`${listId ? 'btn-containe' : 'btn-hide'}`}>
            <button className="btn btn-cancel" onClick={handleCancel}>
              {language.card.item.btn_cancel}
            </button>
          </div>
        }
        {!loading &&
          <div className={`${listId ? 'help-container' : 'help-hide'}`}>
              {"* " + language.card.item.btn_cancel_help}
          </div>
        }
      </div>
    );
  }
}

export default CardItem;



// WEBPACK FOOTER //
// ./source/client/components/account_list/cardItem.jsx